import type { DirectDealsListFilters } from '@openx/components-direct-deals/types';
import type { AllTableCriteria } from '@openx/types/tableCriteria';

export const getQueryListSort = (sort: AllTableCriteria<DirectDealsListFilters>['sort']): string | undefined => {
  if (!sort) return;

  return `${sort.direction === 'desc' ? '-' : ''}${sort.column}`;
};
